import { render, staticRenderFns } from "./UserViewDashboard.vue?vue&type=template&id=00d902e2&"
import script from "./UserViewDashboard.vue?vue&type=script&lang=js&"
export * from "./UserViewDashboard.vue?vue&type=script&lang=js&"
import style0 from "./UserViewDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports